import ReactDOM from "react-dom/client";
import { DbContextProvider } from './context/DbContext'
import { TaskContextProvider } from "./context/TaskContext";
import { VideoContextProvider } from './context/VideoContext';
import { BackIndexProvider } from './context/BackIndex'
import { HelmetProvider } from "react-helmet-async";
import App from "./App";

import "./style/index.css";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <HelmetProvider>
    <DbContextProvider >
      <BackIndexProvider>
        <VideoContextProvider>
          <TaskContextProvider>
            <App />
          </TaskContextProvider>
        </VideoContextProvider>
      </BackIndexProvider>
    </DbContextProvider>
  </HelmetProvider>
);
